
import { Component, Vue } from 'vue-property-decorator';

@Component<AdminPage>({})
export default class AdminPage extends Vue {}
